(function () {
  'use strict';

  if (window.__svcCarouselRuntime) {
    window.__svcCarouselRuntime.initAll(document);
    return;
  }

  function readConfig(root) {
    try {
      return JSON.parse(root.querySelector('[data-svc-config]').textContent);
    } catch (error) {
      return null;
    }
  }

  function updateSoundButton(button, active) {
    if (!button) return;
    var media = button.closest('.svc__media').querySelector('[data-svc-video], [data-svc-youtube]');
    var title = media ? (media.getAttribute('aria-label') || media.getAttribute('title')) : 'video';
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', (active ? 'Pause ' : 'Play ') + title + (active ? '' : ' with sound'));
  }

  function youtubeCommand(iframe, command) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: command, args: [] }), '*');
  }

  function hydrateMedia(media) {
    if (!media || media.dataset.svcHydrated === 'true') return;

    if (media.matches('[data-svc-youtube]')) {
      media.addEventListener('load', function () {
        media.closest('.svc__media').classList.add('svc__media--youtube-ready');
      }, { once: true });
      media.src = media.dataset.src;
      media.dataset.svcHydrated = 'true';
      media.dataset.svcAudible = 'false';
      return;
    }

    if (media.dataset.poster) {
      media.poster = media.dataset.poster;
    }

    media.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    media.dataset.svcHydrated = 'true';
    media.load();
  }

  function initializeSection(root) {
    if (!root || root.dataset.svcInitialized === 'true') return;

    var viewport = root.querySelector('[data-svc-viewport]');
    var track = root.querySelector('[data-svc-track]');
    var options = readConfig(root);
    if (!viewport || !track || !options || Number(options.validEntries) < 1) return;

    root.dataset.svcInitialized = 'true';

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-svc-slide]'));
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var reducedMotion = Boolean(reducedMotionQuery.matches && options.respectReducedMotion);
    var autoplayEnabled = Boolean(options.autoplay && !reducedMotion && slides.length > 1);
    var scrollSpeed = Math.min(100, Math.max(10, Number(options.scrollSpeed) || 35));
    var pauseReasons = new Set();
    var offset = 0;
    var lastFrameTime = 0;
    var lastPreviewTime = 0;
    var animationFrame = null;
    var carouselStarted = false;
    var destroyed = false;
    var sectionObserver;
    var videoObserver;
    var resizeObserver;
    var activePointerId = null;
    var pointerStartX = 0;
    var pointerStartY = 0;
    var pointerLastX = 0;
    var pointerDirection = null;
    var isDragging = false;
    var suppressClick = false;
    var clickResetTimer;
    var resumeTimer;

    root.classList.toggle('svc--continuous', autoplayEnabled);
    root.classList.toggle('svc--static', !autoplayEnabled);

    function allMedia() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-svc-video], [data-svc-youtube]'));
    }

    function setPaused(reason, paused) {
      if (paused) pauseReasons.add(reason);
      else pauseReasons.delete(reason);

      if (pauseReasons.size > 0) stopMotion();
      else startMotion();
    }

    function silenceAll(except) {
      allMedia().forEach(function (media) {
        if (media === except) return;
        if (media.matches('[data-svc-youtube]')) {
          youtubeCommand(media, 'mute');
          youtubeCommand(media, 'pauseVideo');
          media.dataset.svcAudible = 'false';
        } else {
          media.pause();
          media.muted = true;
        }
        updateSoundButton(media.closest('.svc__media').querySelector('[data-svc-sound-toggle]'), false);
      });
    }

    function isSlideVisible(slide) {
      var viewportRect = viewport.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      return slideRect.right > viewportRect.left && slideRect.left < viewportRect.right;
    }

    function previewVisibleVideos() {
      allMedia().forEach(function (media) {
        var slide = media.closest('[data-svc-slide]');
        var isVisible = slide ? isSlideVisible(slide) : false;
        var isYouTube = media.matches('[data-svc-youtube]');
        var isAudible = isYouTube ? media.dataset.svcAudible === 'true' : media.muted === false && !media.paused;

        if (isVisible && options.previewVideos && !reducedMotion && !isAudible && !document.hidden) {
          hydrateMedia(media);
          if (isYouTube) {
            youtubeCommand(media, 'mute');
            youtubeCommand(media, 'playVideo');
          } else {
            media.play().catch(function () {});
          }
        } else if (!isAudible) {
          if (isYouTube) youtubeCommand(media, 'pauseVideo');
          else media.pause();
        }
      });
    }

    function trackGap() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    }

    function slideStep(slide) {
      return slide ? slide.getBoundingClientRect().width + trackGap() : 0;
    }

    function normalizeTrack() {
      var firstSlide = track.firstElementChild;
      var lastSlide = track.lastElementChild;
      var safety = slides.length * 2 + 2;

      while (offset < 0 && lastSlide && safety > 0) {
        var previousStep = slideStep(lastSlide);
        if (!previousStep) break;
        track.insertBefore(lastSlide, firstSlide);
        offset += previousStep;
        firstSlide = track.firstElementChild;
        lastSlide = track.lastElementChild;
        safety -= 1;
      }

      while (firstSlide && safety > 0) {
        var nextStep = slideStep(firstSlide);
        if (!nextStep || offset < nextStep) break;
        offset -= nextStep;
        track.appendChild(firstSlide);
        firstSlide = track.firstElementChild;
        safety -= 1;
      }
    }

    function renderTrack() {
      track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
    }

    function stopMotion() {
      if (animationFrame !== null) {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = null;
      }
      lastFrameTime = 0;
    }

    function startMotion() {
      if (!carouselStarted || !autoplayEnabled || destroyed || pauseReasons.size > 0 || animationFrame !== null) return;
      animationFrame = window.requestAnimationFrame(tick);
    }

    function tick(timestamp) {
      animationFrame = null;
      if (destroyed || !autoplayEnabled || pauseReasons.size > 0) {
        lastFrameTime = 0;
        return;
      }

      if (!lastFrameTime) lastFrameTime = timestamp;
      var elapsed = Math.min(timestamp - lastFrameTime, 50);
      lastFrameTime = timestamp;
      offset += scrollSpeed * elapsed / 1000;
      normalizeTrack();
      renderTrack();

      if (timestamp - lastPreviewTime > 250) {
        lastPreviewTime = timestamp;
        previewVisibleVideos();
      }

      animationFrame = window.requestAnimationFrame(tick);
    }

    function startCarousel() {
      if (carouselStarted) {
        startMotion();
        return;
      }

      carouselStarted = true;
      renderTrack();
      window.requestAnimationFrame(function () {
        previewVisibleVideos();
        startMotion();
      });
    }

    function playYoutubeWithSound(media, button) {
      var activate = function () {
        youtubeCommand(media, 'unMute');
        youtubeCommand(media, 'playVideo');
        media.dataset.svcAudible = 'true';
        updateSoundButton(button, true);
      };

      if (media.closest('.svc__media').classList.contains('svc__media--youtube-ready')) activate();
      else media.addEventListener('load', activate, { once: true });
    }

    root.addEventListener('click', function (event) {
      var soundButton = event.target.closest('[data-svc-sound-toggle]');
      if (!soundButton || !root.contains(soundButton)) return;

      var media = soundButton.closest('.svc__media').querySelector('[data-svc-video], [data-svc-youtube]');
      var isYouTube = media.matches('[data-svc-youtube]');
      var isAudible = isYouTube ? media.dataset.svcAudible === 'true' : media.muted === false && !media.paused;

      if (isAudible) {
        if (isYouTube) {
          youtubeCommand(media, 'mute');
          youtubeCommand(media, 'pauseVideo');
          media.dataset.svcAudible = 'false';
        } else {
          media.pause();
          media.muted = true;
        }
        updateSoundButton(soundButton, false);
        setPaused('audio', false);
        return;
      }

      hydrateMedia(media);
      silenceAll(media);
      setPaused('audio', true);

      if (isYouTube) {
        playYoutubeWithSound(media, soundButton);
        return;
      }

      media.muted = false;
      media.play().then(function () {
        updateSoundButton(soundButton, true);
      }).catch(function () {
        media.muted = true;
        updateSoundButton(soundButton, false);
        setPaused('audio', false);
      });
    });

    root.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-svc-cart-form]');
      if (!form || !root.contains(form)) return;
      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      var slide = form.closest('[data-svc-slide]');
      var status = slide ? slide.querySelector('[data-svc-status]') : null;
      var wasDisabled = button.disabled;

      button.disabled = true;
      if (status) status.textContent = 'Adding…';

      var routeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Unable to add item');
            });
          }
          return response.json();
        })
        .then(function (item) {
          return fetch(routeRoot + 'cart.js').then(function (response) {
            if (!response.ok) throw new Error('Unable to refresh cart');
            return response.json();
          }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('variant:add', {
              bubbles: true,
              detail: { items: [item], cart: cart }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (status) status.textContent = 'Added to cart';
          });
        })
        .catch(function (error) {
          if (status) status.textContent = error.message || 'Could not add this item. Please try again.';
        })
        .finally(function () {
          button.disabled = wasDisabled;
        });
    });

    function handleVisibilityChange() {
      setPaused('visibility', document.hidden);
      if (document.hidden) {
        silenceAll();
        setPaused('audio', false);
      } else {
        previewVisibleVideos();
      }
    }

    function handlePointerEnter(event) {
      if (event.pointerType === 'mouse') setPaused('hover', true);
    }

    function handlePointerLeave(event) {
      if (event.pointerType === 'mouse') setPaused('hover', false);
      if (activePointerId === null) setPaused('pointer', false);
    }

    function handlePointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      window.clearTimeout(resumeTimer);
      activePointerId = event.pointerId;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      pointerLastX = event.clientX;
      pointerDirection = null;
      isDragging = false;
      setPaused('pointer', true);
      startCarousel();
    }

    function handlePointerMove(event) {
      if (activePointerId !== event.pointerId) return;

      var totalX = event.clientX - pointerStartX;
      var totalY = event.clientY - pointerStartY;

      if (!pointerDirection) {
        var dragThreshold = event.pointerType === 'touch' ? 12 : 6;
        if (Math.abs(totalX) < dragThreshold && Math.abs(totalY) < dragThreshold) return;
        pointerDirection = Math.abs(totalX) > Math.abs(totalY) ? 'horizontal' : 'vertical';

        if (pointerDirection === 'vertical') {
          setPaused('pointer', false);
          return;
        }

        if (viewport.setPointerCapture) {
          try { viewport.setPointerCapture(event.pointerId); } catch (error) {}
        }
        isDragging = true;
        root.classList.add('svc--dragging');
      }

      if (pointerDirection !== 'horizontal') return;
      event.preventDefault();

      var movement = event.clientX - pointerLastX;
      pointerLastX = event.clientX;
      offset -= movement;
      normalizeTrack();
      renderTrack();
      previewVisibleVideos();
    }

    function finishPointerInteraction(event, cancelled) {
      if (activePointerId !== event.pointerId) return;

      if (viewport.releasePointerCapture && viewport.hasPointerCapture && viewport.hasPointerCapture(event.pointerId)) {
        try { viewport.releasePointerCapture(event.pointerId); } catch (error) {}
      }

      if (isDragging && viewport.contains(document.activeElement) && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }

      if (isDragging && !cancelled) {
        suppressClick = true;
        window.clearTimeout(clickResetTimer);
        clickResetTimer = window.setTimeout(function () { suppressClick = false; }, 400);
      }

      activePointerId = null;
      pointerDirection = null;
      isDragging = false;
      root.classList.remove('svc--dragging');
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () { setPaused('pointer', false); }, cancelled ? 0 : 900);
    }

    function handlePointerUp(event) {
      finishPointerInteraction(event, false);
    }

    function handlePointerCancel(event) {
      finishPointerInteraction(event, true);
    }

    function suppressDraggedClick(event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }

    function handleFocusIn() {
      setPaused('focus', true);
      startCarousel();
    }

    function handleFocusOut() {
      window.setTimeout(function () {
        setPaused('focus', viewport.contains(document.activeElement));
      }, 0);
    }

    viewport.addEventListener('pointerenter', handlePointerEnter);
    viewport.addEventListener('pointerleave', handlePointerLeave);
    viewport.addEventListener('pointerdown', handlePointerDown, { passive: true });
    viewport.addEventListener('pointermove', handlePointerMove, { passive: false });
    viewport.addEventListener('pointerup', handlePointerUp, { passive: true });
    viewport.addEventListener('pointercancel', handlePointerCancel, { passive: true });
    viewport.addEventListener('click', suppressDraggedClick, true);
    viewport.addEventListener('focusin', handleFocusIn);
    viewport.addEventListener('focusout', handleFocusOut);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        offset = 0;
        renderTrack();
        previewVisibleVideos();
      });
      resizeObserver.observe(viewport);
    }

    if ('IntersectionObserver' in window) {
      videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var media = entry.target.querySelector('[data-svc-video], [data-svc-youtube]');
          hydrateMedia(media);
        });
        previewVisibleVideos();
      }, { root: viewport, rootMargin: '100% 50%', threshold: 0 });

      slides.forEach(function (slide) {
        videoObserver.observe(slide);
      });

      sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          if (entry.isIntersecting) {
            setPaused('offscreen', false);
            startCarousel();
          } else {
            setPaused('offscreen', true);
            silenceAll();
            setPaused('audio', false);
          }
        });
      }, { rootMargin: '300px 0px' });
      pauseReasons.add('offscreen');
      sectionObserver.observe(root);
    } else {
      slides.forEach(function (slide) {
        hydrateMedia(slide.querySelector('[data-svc-video], [data-svc-youtube]'));
      });
      startCarousel();
    }

    root.addEventListener('svc:destroy', function () {
      destroyed = true;
      window.clearTimeout(clickResetTimer);
      window.clearTimeout(resumeTimer);
      stopMotion();
      silenceAll();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      viewport.removeEventListener('pointerenter', handlePointerEnter);
      viewport.removeEventListener('pointerleave', handlePointerLeave);
      viewport.removeEventListener('pointerdown', handlePointerDown);
      viewport.removeEventListener('pointermove', handlePointerMove);
      viewport.removeEventListener('pointerup', handlePointerUp);
      viewport.removeEventListener('pointercancel', handlePointerCancel);
      viewport.removeEventListener('click', suppressDraggedClick, true);
      viewport.removeEventListener('focusin', handleFocusIn);
      viewport.removeEventListener('focusout', handleFocusOut);
      if (sectionObserver) sectionObserver.disconnect();
      if (videoObserver) videoObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      track.style.removeProperty('transform');
      root.classList.remove('svc--continuous', 'svc--static', 'svc--dragging');
      root.dataset.svcInitialized = 'false';
    }, { once: true });
  }

  function initAll(scope) {
    var container = scope || document;
    if (container.matches && container.matches('[data-svc-section]')) initializeSection(container);
    container.querySelectorAll('[data-svc-section]').forEach(initializeSection);
  }

  window.__svcCarouselRuntime = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches('[data-svc-section]')
      ? event.target
      : event.target.querySelector('[data-svc-section]');
    if (root) root.dispatchEvent(new CustomEvent('svc:destroy'));
  });
})();

